import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const query = atom({
    key: "query",
    default: '',
    // effects_UNSTABLE: [persistAtom],
});

export const category = atom({
    key: "category",
    default: -1,
});

export const freeShipping = atom({
    key: "freeShipping",
    default: false,
});

export const company = atom({
    key: "company",
    default: -1,
});

export const price = atom({
    key: "price",
    default: 309999,
    effects_UNSTABLE: [persistAtom],
});